import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { 
  Delete_ListPrice, 
  Get_AllListPricePaginated, 
  Get_ListPrice, 
  Save_ListPrice, 
  Update_ListPrice,
  //Delete_MultipleListPrices
} from 'app/graphql/listprice.graphql';

@Injectable({
  providedIn: 'root'
})
export class MockService {
  private apollo = inject(Apollo);
  
  async get(options: {
    page?: number;
    limit?: number;
    search?: string;
    filters?: any;
    sortBy?: string;
    sortOrder?: string;
  } = {}) {
    const { page = 1, limit = 10, search, filters, sortBy, sortOrder } = options;
    
    try {
      const result = await firstValueFrom(
        this.apollo.query({
          query: Get_AllListPricePaginated,
          variables: {
              options: {
                page,
                limit,
                search: search || undefined,
                filters: JSON.stringify(filters) || "{}",
                sortBy,
                sortOrder
              }
          },
          fetchPolicy: 'network-only'
        })
      );

      const data = result.data as any;
      if (data && data.price_lists_paginated) {
        return {
          response: data.price_lists_paginated.price_lists,
          total: data.price_lists_paginated.total,
          skip: data.price_lists_paginated.skip,
          limit: data.price_lists_paginated.limit
        };
      }
      
      throw new Error('No data returned from GraphQL query');
    } catch (error) {
      console.error('Error fetching data', error);
      throw error;
    }
  }

  async getById(id: string, code: string, name: string) {
    try {
      const result = await firstValueFrom(
        this.apollo.query({
          query: Get_ListPrice,
          variables: {
            id,
            code,
            name,
            search: id,
            limit: 1
          },
          fetchPolicy: 'network-only'
        })
      );

      const data = result.data as any;
      if (data && data.price_list) {
        return data.price_list;
      }
      
      throw new Error(`Price list with id ${id} not found`);
    } catch (error) {
      console.error(`Error fetching price list with id ${id}`, error);
      throw error;
    }
  }

  async add(item: any) {
    try {
      const result = await firstValueFrom(
        this.apollo.mutate({
          mutation: Save_ListPrice,
          variables: {
            data: item
          }
        })
      );
      const data = result.data as any;
      if (data && data.createPrice_list) {
        return data.createPrice_list;
      }
      throw new Error('No data returned from GraphQL mutation');
    } catch (error) {
      console.error('Error saving price list', error);
      throw error;
    }
  }

  async delete(id: string, v_?: string) {
    try {
      const result = await firstValueFrom(
        this.apollo.mutate({
          mutation: Delete_ListPrice,
          variables: {
            data: { id, v_ }
          }
        })
      );
      const data = result.data as any;
      if (data && data.deletePrice_list) {
        return data.deletePrice_list;
      }
      throw new Error('No data returned from GraphQL mutation');
    } catch (error) {
      console.error('Error deleting price list', error);
      throw error;
    }
  }

  async update(id: string, item: any) {
    try {
      const result = await firstValueFrom(
        this.apollo.mutate({
          mutation: Update_ListPrice,
          variables: {
            id,
            data: item
          }
        })
      );
      const data = result.data as any;
      if (data && data.updatePrice_list) {
        return data.updatePrice_list;
      }
      throw new Error('No data returned from GraphQL mutation');
    } catch (error) {
      console.error('Error updating price list', error);
      throw error;
    }
  }

  // async deleteMultiple(ids: string[]) {
  //   try {
  //     if (!ids || ids.length === 0) {
  //       throw new Error('No se proporcionaron IDs para eliminar');
  //     }

  //     const result = await firstValueFrom(
  //       this.apollo.mutate({
  //         mutation: Delete_MultipleListPrices,
  //         variables: {
  //           ids
  //         },
  //         // Actualizar la caché después de la eliminación
  //         update: (cache) => {
  //           // Limpiar la caché para forzar una nueva solicitud
  //           cache.evict({ fieldName: 'price_lists_paginated' });
  //           cache.gc();
  //         }
  //       })
  //     );

  //     const data = result.data as any;
  //     if (data && data.deleteMultiplePrice_lists) {
  //       return data.deleteMultiplePrice_lists;
  //     }
      
  //    throw new Error('No se recibieron datos válidos de la mutación');
  //  } catch (error) {
  //    console.error('Error al eliminar múltiples precios de lista', error);
  //    throw error;
  //  }

  async getOptions(model: string, query: any, responseName: string) {
    try {
      const result = await firstValueFrom(
        this.apollo.query({
          query,
          variables: {
            model
          },
          fetchPolicy: 'network-only'
        })
      );

      const data = result.data as any;
      if (data && data[responseName]) {
        return data[responseName];
      }
      
      throw new Error('No data returned from GraphQL query');
    } catch (error) {
      console.error('Error fetching data', error);
      throw error;
    }
  }
}
